var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mobile-header" }, [
    _vm.activeSubMenu
      ? _c(
          "div",
          {
            staticClass: "mobile-header__back",
            on: {
              click: function ($event) {
                _vm.activeSubMenu = null
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icons/i_arrow-red.svg"),
                alt: "arrow",
              },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-header__close", on: { click: _vm.closeMenu } },
      [
        _c("img", {
          attrs: { src: require("@/assets/icons/i_close.svg"), alt: "close" },
        }),
      ]
    ),
    _vm._v(" "),
    !_vm.activeSubMenu
      ? _c("div", { staticClass: "mobile-header__nav" }, [
          _c(
            "ul",
            { staticClass: "mobile-header__nav-links" },
            _vm._l(_vm.menu, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: { "not-access": _vm.checkAccess(item.access) },
                },
                [
                  item.tag
                    ? _c(
                        "a",
                        { attrs: { href: item.link, target: "_blank" } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.title) + "\n        "
                          ),
                        ]
                      )
                    : _c("nuxt-link", { attrs: { to: item.link } }, [
                        _vm._v(
                          "\n          " + _vm._s(item.title) + "\n        "
                        ),
                      ]),
                  _vm._v(" "),
                  item.submenu
                    ? _c("img", {
                        attrs: {
                          src: require("../../assets/icons/i_arrow-right.svg"),
                          alt: "arrow",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openSubMenu(item)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "mobile-header__nav-profile" }, [
            _vm.isAuthorize
              ? _c("li", [
                  _c("div", { staticClass: "mobile-header__logout" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "18",
                          height: "18",
                          viewBox: "0 0 18 18",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "#003865",
                            d: "M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v("MYPC")]),
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: require("@/assets/icons/i_arrow-right.svg"),
                      alt: "arrow",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openSubMenu(_vm.profileMenu)
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isAuthorize
              ? _c("li", [
                  _c(
                    "button",
                    {
                      staticClass: "mobile-header__logout",
                      on: { click: _vm.handleLogout },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16.83",
                            height: "19",
                            viewBox: "0 0 16.83 19",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Icon:_Logout",
                                "data-name": "Icon: Logout",
                                transform: "translate(-35.861 0.501)",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  fill: "#003865",
                                  d: "M47.354,66.878a.63.63,0,0,0-.816.355h0a.633.633,0,0,0,.356.817,7.155,7.155,0,1,1-5.236,0,.63.63,0,0,0,.021-1.164.624.624,0,0,0-.481-.008,8.415,8.415,0,1,0,6.157,0Z",
                                  transform: "translate(0 -64.626)",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  fill: "#003865",
                                  d: "M229.225,11.583a.7.7,0,0,0,.7-.7V.2a.7.7,0,1,0-1.406,0V10.88A.7.7,0,0,0,229.225,11.583Z",
                                  transform: "translate(-184.909)",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", [_vm._v("LOGOUT")]),
                    ]
                  ),
                ])
              : _c(
                  "li",
                  [
                    _c(
                      "nuxt-link",
                      {
                        staticClass: "mobile-header__logout",
                        attrs: { to: "/login" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "18",
                              height: "18",
                              viewBox: "0 0 18 18",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#003865",
                                d: "M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v("LOGIN")]),
                      ]
                    ),
                  ],
                  1
                ),
          ]),
        ])
      : _c("div", { staticClass: "mobile-header__subnav" }, [
          _c("p", { staticClass: "mobile-header__subnav-title" }, [
            _vm._v("\n      " + _vm._s(_vm.activeSubMenu.title) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.activeSubMenu.submenu, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: {
                    "not-subscribe":
                      (_vm.notSubscribeEurope &&
                        item.link === "/benchmarking/europe") ||
                      (_vm.notSubscribeAmerica &&
                        item.link === "/benchmarking/north-america"),
                  },
                },
                [
                  _c("nuxt-link", { attrs: { to: item.link } }, [
                    _vm._v("\n          " + _vm._s(item.title) + "\n        "),
                  ]),
                  _vm._v(" "),
                  _vm.notSubscribeEurope || _vm.notSubscribeAmerica
                    ? _c("Tooltip")
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }